import { Component, signal, inject } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { PlantaChipComponent } from './components/common/planta-chip/planta-chip.component';
import { SideNavComponent } from './components/common/side-nav/side-nav.component';
import { ContextService } from './services/context.service';
import { LocalDbService } from './services/local-db.service';
import { PermissionService } from './services/permissions.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SideNavComponent, PlantaChipComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Trazabilidad de semillas';

  private router = inject(Router);
  private readonly localDb = inject(LocalDbService);
  private readonly ctx = inject(ContextService);
  private readonly permissionService = inject(PermissionService);
  public isLoginPage = signal<boolean>(false);

  constructor() {
    this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isLoginPage.set(event.urlAfterRedirects.includes('/login'));
    });

    this.localDb.getLoginData().then((savedData) => {
      if (savedData) this.ctx.init(savedData);
    });
    this.permissionService.ensureLoaded();
  }
}
